
  export default {
'button' : { 

 typeTheme :{ 
 'cancelSubscribe' : { 
  'position' : 'absolute',
  'bottom' : '0',
  'width' : '387px'
 
}} 
}
,
'block' : { 

 typeTheme :{ 
 'onestoreSubscribePageContainer' : { 
  'padding' : '15px 79px'
 
},
 'subscribeManageDetailContent' : { 
  'position' : 'relative',
  'display' : 'flex',
  'justify-content' : 'space-between',
  'width' : '852px',
  'height' : '406px',
  'min-height' : '85vh'
 
},
 'subscribeManageDetail' : { 
  'position' : 'relative',
  'width' : '426px',
  'margin-bottom' : '30px'
 
},
 'subscribeDetailTip' : { 
  'width' : '428px',
  'position' : 'absolute',
  'left' : '0',
  'top' : '219px'
 
},
 'onestoreSubscribeTimeItem' : { 
  'height' : '127px'
 
},
 'onestoreSubscribeTimeItem-active' : { 
  'height' : '127px'
 
},
 'onestoreSubscribeDetailItem' : { 
  'padding' : '21px 17px'
 
}} 
}
,
'mark' : { 

 typeTheme :{ 
 'subscribeItemDetailPrices1' : { 
  'display' : 'none'
 
},
 'subscribeItemDetailPrices2' : { 
  'display' : 'block',
  'color' : '#333',
  'font-size' : '23.6px',
  'text-decoration' : 'none'
 
}} 
}

}